import { AfterViewInit, Directive, ElementRef, HostBinding, HostListener, Renderer2, ViewContainerRef } from '@angular/core';
import { SidenavContentService } from './sidenav-content.service';

@Directive({
    selector: '[sidenavContentContainer]',
})
export class SidenavContentContainerDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}

@Directive({
    selector: `[sidenav-close], sidenav-close, [sidenav-close]`,
})
export class SidenavCloseDirective {
    constructor(private _sidenav: SidenavContentService) {
    }

    @HostListener('click', ['$event']) onClick($event: MouseEvent){
        this._sidenav.close();
    }
}

@Directive({
    selector: `[sidenav-content-header], sidenav-content-header, [sidenavContentHeader]`,
})
export class SidenavContentHeaderDirective {
    @HostBinding('class') classValue = 'sidenav-content-header';
}

@Directive({
    selector: `[sidenav-content], sidenav-content, [sidenavContent]`,
})
export class SidenavContentDirective {
    @HostBinding('class') classValues = 'sidenav-content animated fadeIn';
}

@Directive({
    selector: `[sidenav-title], sidenav-title, [sidenavTitle]`,
})
export class SidenavTitleDirective implements AfterViewInit {
    constructor(private _renderer: Renderer2, private _el: ElementRef, private _sidenav: SidenavContentService) {
    }

    ngAfterViewInit() {
        this._sidenav._title = this._el.nativeElement.textContent;
        this._renderer.removeChild(this._el.nativeElement.parent, this._el.nativeElement);
    }
}

@Directive({
    selector: `[sidenav-actions], sidenav-actions, [sidenavActions]`,
})
export class SidenavActionsDirective implements AfterViewInit {
    constructor(private _el: ElementRef, private _sidenav: SidenavContentService) {
    }

    ngAfterViewInit(): void {
        this._sidenav._actions = this._el;
    }
}
